import { z } from "../../common-utils/zod/index.js";
import isString from "../string/isString.util.js";
import isEmptyString from "../string/isEmptyString.util.js";
export const isEmailUtil = (input) => {
    if (!isString(input) || isEmptyString(input)) {
        return false;
    }
    const { success } = z.string().email().safeParse(input);
    return success;
};
export default isEmailUtil;
